import { render, staticRenderFns } from "./SelectVideoGalleryItem.vue?vue&type=template&id=8659d4b8&"
import script from "./SelectVideoGalleryItem.vue?vue&type=script&lang=js&"
export * from "./SelectVideoGalleryItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports